module.exports = __webpack_public_path__ + "static/media/leal_logo_2.14a8a9c5.svg";